type FileFormat =
  | 'pdf'
  | 'doc'
  | 'docx'
  | 'xls'
  | 'xlsx'
  | 'ppt'
  | 'pptx'
  | 'txt'
  | 'jpg'
  | 'jpeg'
  | 'png'
  | 'gif'
  | 'zip'
  | 'rar'
  | 'mp4'
  | 'unknown';

export const getFileFormat = (fileName: string): FileFormat => {
  const extension = fileName.split('.').pop()?.toLowerCase();

  const formatMap: Record<string, FileFormat> = {
    pdf: 'pdf',
    doc: 'doc',
    docx: 'docx',
    xls: 'xls',
    xlsx: 'xlsx',
    ppt: 'ppt',
    pptx: 'pptx',
    txt: 'txt',
    jpg: 'jpg',
    jpeg: 'jpg',
    png: 'png',
    gif: 'gif',
    zip: 'zip',
    rar: 'rar',
    mp4: 'mp4'
  };

  return formatMap[extension || ''] || 'unknown';
};
